import styled from 'styled-components';

export const AudioChatBallon = styled.audio`
  max-width: 110%;
`;
